import { TasksSection } from "@/features/cases/components/tasks-section";
import { useActiveClient } from "@/layouts/client-layout";

export default function ClientTasksPage() {
  const { client } = useActiveClient();
  return (
    <div className="space-y-6">
      <TasksSection clientId={client.id} />
    </div>
  );
}
